$('#tax_cleared').on('change', function () {
    if(!checkIfValidFromDateIsInFuture() && $(this).is(':checked')) {
        $(this).prop('checked', false);

        Swal.fire({
            title: 'Fehler',
            icon: 'warning',
            text: 'Nachw. z. Steuer sch. des Leistungsem. enthält keinen gültigen Wert',
            showConfirmButton: false,
        });
    }
});

function checkIfValidFromDateIsInFuture() {
    let dateInputValue = $('#valid_from').val();
    if(dateInputValue === '') {
        return true;
    }

    let dateArray = dateInputValue.split('.');
    let date = new Date(dateArray[2], dateArray[1] - 1, dateArray[0]);
    let dateNow = new Date();

    return date > dateNow;
}
